export const EstopStateEnum = Object.freeze({
  Unknown: 'Unknown',
  Triggered: 'Triggered',
  Released: 'Released',
});
